import { render, staticRenderFns } from "./CbsDataEntity.vue?vue&type=template&id=083c683a&scoped=true"
import script from "./CbsDataEntity.vue?vue&type=script&lang=js"
export * from "./CbsDataEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c683a",
  null
  
)

export default component.exports